module.exports = __webpack_public_path__ + "img/img_product_warper_8.721ca99d.jpg";